import { useCallback } from "react";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "@/components/themeProvider";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

export function ThemeSwitcher() {
  const { setTheme, theme } = useTheme();
  const { t } = useTranslation();

  const toggleTheme = useCallback(() => {
    setTheme(theme === "dark" ? "light" : "dark");
  }, [theme, setTheme]);

  return (
    <Button variant="ghost" className="group/toggle size-8 px-0" onClick={toggleTheme}>
      <SunIcon className="hidden [html.dark_&]:block" />
      <MoonIcon className="hidden [html.light_&]:block" />
      <span className="sr-only">{t("theme.toggle")}</span>
    </Button>
  );
}
